<page-load-header *ngIf="!initialized"></page-load-header>

<gaitcapability-assessment-result-details [isShared]="true"></gaitcapability-assessment-result-details>


